import { BaseService } from "./base.service";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs";
import { CertificateNew, CertificateResponse } from "../models/certificate.model";
import { SassCertificatesModel } from "../models/sassCertificate.model";

@Injectable({
  providedIn: "root"
})
export class CertificateService extends BaseService {
  className = "CertificateService";

  constructor(injector: Injector) {
    super(injector);
  }

  addNewCertificate(isReadDataFromSassEnabled: boolean, model: CertificateNew): Observable<CertificateResponse> {
    const apiVersion = isReadDataFromSassEnabled ? '2' : '1';
    return this.postAny<CertificateResponse>(`/v${apiVersion}/certificate`, model);
  }

  deleteCertificate(certificateGuid: string): Observable<object> {
    return this.delete(`/v2/certificates/${certificateGuid}`);
  }

  getCurrentAccountCertificates(): Observable<SassCertificatesModel> {
    return this.get<SassCertificatesModel>(`/v2/certificates/current`);
  }
}